import { isEmptyString } from '@/utils/string';

export interface UserWithName {
  first_name?: string;
  last_name?: string;
  email: string;
}

/**
 * Get the display name for a user (full name if available, otherwise email).
 * Trims whitespace from each name part.
 */
export function getUserDisplayName(user: UserWithName): string {
  const firstName = user.first_name?.trim() ?? '';
  const lastName = user.last_name?.trim() ?? '';
  const fullName = [firstName, lastName].filter(Boolean).join(' ');
  return !isEmptyString(fullName) ? fullName : user.email;
}
